import {
  useCallback,
  useContext,
  useState,
  createContext,
  useEffect
} from 'react';

//Redux
import { useSelector } from 'react-redux';
import './notification.css';

//Icons
import { OkIcon } from '@/assets/icons';

const ToastContext = createContext();

export default ToastContext;

export function NotificationProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const { primaryColor } = useSelector(({ theme }) => theme);

  const addToast = useCallback(
    function (toast, state = true) {
      setToasts((toasts) => [...toasts, { text: toast, state: state }]);
      setTimeout(() => setToasts((toasts) => toasts.slice(1)), 3000);
    },
    [setToasts]
  );

  const SVGTrue = () => <div>✅</div>;
  const SVGFalse = () => <div>❌</div>;
  const SVGNull = () => <div>⚪</div>;

  useEffect(() => {
    if (toasts.length === 0) return;
    const timer = setTimeout(() => {
      setToasts((toasts) => toasts.slice(1));
    }, 3000);
    return () => clearTimeout(timer);
  }, [toasts]);

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <div className="toastContainerStyle">
        {toasts.map((toast, index) => (
          <div
            key={index}
            className="toastContentStyle"
            style={{ background: primaryColor }}
          >
            {toast.state === true && <OkIcon />}
            {toast.state === false && <SVGFalse />}
            {toast.state === null && <SVGNull />}
            <p style={{ margin: '0px' }}>{toast.text}</p>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToastContext() {
  return useContext(ToastContext);
}
